// removed by extract-text-webpack-plugin
module.exports = {"box":"_35QRXoMT0rF0cBDCpKIUgp","smallBox":"_3FGB8EQYx9MsCQGFvRDZYm","loadingBox":"_2UaUIXeb6f2905E0PGxmG","textBox":"q9Ib87BKEiMuABSD90-24","message":"_3pjUNx9IreWepYFvU-99lY","statusBox":"_-VD5cuQ0ZBlLUs6VSiBEP","wait":"_12Li81Ux_2W5K3jwCeK8_K","accept":"_1dQqe4aDkVPWX3smzG_z0z","cancel":"_2XrxE8JROTiA7drRWZ29Dx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/QRStatus.scss
// module id = 451
// module chunks = 0